import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import ListingTitle from '@spotahome/ui-library/src/tenant/components/ListingTitle';

import HowToBook from './HowToBook';

import { ListingSectionObservable } from './ListingSection';

const ListingHowToBook = ({ hasVetting = false }) => (
  <ListingSectionObservable section="howToBook">
    <ListingTitle role="secondary">
      {trans('listing.how-to-book.section-main-title')}
    </ListingTitle>
    <HowToBook hasVetting={hasVetting} />
  </ListingSectionObservable>
);

ListingHowToBook.propTypes = {
  hasVetting: PropTypes.bool
};

export default ListingHowToBook;
